import React from 'react';

import PropTypes from 'prop-types';
import { FaHeart } from 'react-icons/fa';

export default function FavoriteIcon({
  color = 'currentColor',
  count = 0,
  height = 16,
  width = 18,
  ...rest
}) {
  if (count !== 0) {
    return <FaHeart fontSize={height} />;
  } else {
    return (
      <svg viewBox="0 0 18 16" width={width} height={height} {...rest}>
        <path
          fill={color}
          d="M9.0004 1.38535C8.01707 0.494479 6.72998 4.13947e-05 5.39415 0C4.6871 0.00072531 3.98718 0.13921 3.33466 0.407486C2.68215 0.675761 2.08992 1.06853 1.59206 1.56319C-0.531439 3.66433 -0.530536 6.95076 1.59387 9.04301L8.21074 15.5625C8.36416 15.8284 8.66017 16 9.0004 16C9.1401 15.9987 9.27753 15.9651 9.40166 15.9019C9.52579 15.8387 9.63316 15.7478 9.71515 15.6363L16.4069 9.04301C18.5313 6.94987 18.5313 3.66433 16.4051 1.55963C15.9075 1.06588 15.3158 0.673911 14.6639 0.406254C14.012 0.138597 13.3129 0.000533161 12.6066 0C11.2708 0.000215146 9.98382 0.494629 9.0004 1.38535ZM15.129 2.81694C16.5396 4.21385 16.5405 6.39591 15.1308 7.78571L9.0004 13.8259L2.86995 7.78571C1.4603 6.39591 1.4612 4.21385 2.86815 2.8205C3.55402 2.14827 4.45107 1.77837 5.39415 1.77837C6.33722 1.77837 7.23066 2.14827 7.91112 2.81872L8.36235 3.26331C8.44609 3.34596 8.54555 3.41152 8.65503 3.45626C8.76451 3.50099 8.88187 3.52402 9.0004 3.52402C9.11892 3.52402 9.23628 3.50099 9.34576 3.45626C9.45525 3.41152 9.5547 3.34596 9.63844 3.26331L10.0897 2.81872C11.4542 1.47694 13.7663 1.48049 15.129 2.81694Z"
        />
      </svg>
    );
  }
}

FavoriteIcon.propTypes = {
  color: PropTypes.string,
  count: PropTypes.number,
  height: PropTypes.number,
  width: PropTypes.number,
};
